import React from 'react'
import _ from 'lodash'
import { LazyLoadComponent } from 'react-lazy-load-image-component'

// requires a webp image to exist
// see https://web.dev/codelab-serve-images-webp/ for details
// you can run this script in `irb` to generate webps for all images:

// install webp first: `brew install webp`

// Dir.glob("public/images/**/*").select {|p| File.extname(p) != ".webp"}.each do |path|
//   new_path = path.sub(File.extname(path), ".webp")
//   File.delete(new_path) if File.exist?(new_path)
//   `cwebp -q 100 "#{path}" -o "#{new_path}"`
// end
const InternalOptimisedImage = props => {
  if (!props.src) {
    return (
      <img {...props} /> // eslint-disable-line
    )
  }

  const ext = props.src.split('.').pop()
  // we know for a fact that svgs won't work. if this is called it's a dev error.
  if (ext === 'svg' || ext === 'gif') {
    return (
      <img {...props} /> // eslint-disable-line
    )
  }

  const cssClass = props.className
  const imgProps = _.omit(props, 'className')
  const webp = props.src.replace(ext, 'webp')
  const webpProps = _.omit(imgProps, 'src')

  return (
    <picture className={cssClass}>
      <source type="image/webp" srcSet={webp} {...webpProps} />
      <img {...imgProps} className="object-contain"/> {/* eslint-disable-line */}
    </picture>
  )
}

const OptimisedImage = props => {
  return (
    <LazyLoadComponent
      threshold={250}
    >
      <InternalOptimisedImage {...props} />
    </LazyLoadComponent>
  )
}

export default OptimisedImage
